<template>
  <div class="index">
    <div
      class="i_1"
      id="i_1"
      :style="{
        background: 'url(' + imgSiteNum0 + ') no-repeat center center',
      }"
    >
      <div class="i_1_ding">
        <div class="halababy_ix_3">
          <div class="halababy_ix_2">
            <div>
              <img  @mouseover="changeInterval(true)" 
                @mouseleave="changeInterval(false)"  
                v-for="(item,index) in imgArr" 
                :key="item.id"
                :src="item.url" 
                v-show="index===currentIndex" 
                >
            </div>
          </div>
          <p class="halababy_ix_1">{{testList[19]}}</p>
        </div>
      </div>
    </div>
    <div class="i_2">
      <moduleTitle2 :title="testList[0]" :description="testList[1]"></moduleTitle2>
      <div class="i_2_cont">
        <div>
          <img class="i_2_contimg" :src="imgSiteNum3" />
          <p>{{ testList[2] }}</p>
        </div>
        <div>
          <img class="i_2_contimg" :src="imgSiteNum4" />
          <p>{{ testList[3] }}</p>
        </div>
        <div>
          <img class="i_2_contimg" :src="imgSiteNum5" />
          <p>{{ testList[4] }}</p>
        </div>
        <div>
          <img class="i_2_contimg" :src="imgSiteNum6" />
          <p>{{ testList[5] }}</p>
        </div>
        <div>
          <img class="i_2_contimg" :src="imgSiteNum7" />
          <p>{{ testList[6] }}</p>
        </div>
        <div>
          <img class="i_2_contimg" :src="imgSiteNum8" />
          <p>{{ testList[7] }}</p>
        </div>
      </div>
    </div>
    <div class="i_3">
      <moduleTitle2 :title="testList[8]" :description="testList[9]"></moduleTitle2>
      <div class="i_3_cont">
        <div class="i_3_cont_1">
          <img class="bgyuan" src="../assets/sz6.png" />
          <img class="bgtiao" src="../assets/sz2.png" />
          <img class="bie_1" :src="imgSiteNum9" />
          <p class="i_3_cont_1_t">{{ testList[20] }}</p>
          <p class="i_3_cont_1_c">
            {{ testList[10] }}
          </p>
        </div>
        <div class="i_3_cont_1">
          <img class="bgyuan" src="../assets/sz6.png" />
          <img class="bgtiao" src="../assets/sz2.png" />
          <img class="bie_1" :src="imgSiteNum10" />
          <p class="i_3_cont_1_t">{{ testList[21] }}</p>
          <p class="i_3_cont_1_c">
            {{ testList[11] }}
          </p>
        </div>
        <div class="i_3_cont_1">
          <img class="bgyuan" src="../assets/sz6.png" />
          <img class="bgtiao" src="../assets/sz2.png" />
          <img class="bie_1" :src="imgSiteNum11" />
          <p class="i_3_cont_1_t">{{ testList[22] }}</p>
          <p class="i_3_cont_1_c">
            {{ testList[12] }}
          </p>
        </div>
      </div>
    </div>
    <div class="i_4">
      <!-- <div class="i_4_abuout">ABOUT US</div>
      <div class="i_4_lan"></div>
      <div class="i_4_jj">{{ siteNum13 }}</div>
      <div class="i_4_jjcon">
        {{ siteNum14 }}
      </div> -->
      <div class="i_4_con">
        <div class="i_4_con_bg i_4_1cb" 
            @mouseover="mouseOver(0)" 
            @mouseleave="mouseLeave(0)"
            :style="{background: bg0.background}">
          <img :src="imgSiteNum12" />
          <p class="i_4_con_bg_sc">{{ testList[13] }}</p>
          <div class="xuxian"></div>
          <p class="i_4_con_bg_ms">
            {{ testList[16] }}
          </p>
        </div>
        <div class="i_4_con_bg i_4_2cb"
            @mouseover="mouseOver(1)" 
            @mouseleave="mouseLeave(1)"
            :style="{background: bg1.background}">
          <img :src="imgSiteNum13" />
          <p class="i_4_con_bg_sc">{{ testList[14] }}</p>
          <div class="xuxian"></div>
          <p class="i_4_con_bg_ms">
            {{ testList[17] }}
          </p>
        </div>
        <div class="i_4_con_bg i_4_2cb"
            @mouseover="mouseOver(2)" 
            @mouseleave="mouseLeave(2)"
            :style="{background: bg2.background}">
          <img :src="imgSiteNum18" />
          <p class="i_4_con_bg_sc">{{ testList[15] }}</p>
          <div class="xuxian"></div>
          <p class="i_4_con_bg_ms">
            {{ testList[19] }}
          </p>
        </div>
      </div>
      <div class="i_4_liaojie">
        <router-link to="/about">{{ testList[23] }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import moduleTitle2 from "./component/moduleTitle2";

export default {
  name: "index",
  components: {
    moduleTitle2,
  },
  props: ["langType"],
  watch: {
    langType: function (type) {
      this.changeLang(type);
    },
  },
  created(){
    this.mouseOver(0)
  },
  mounted: function () {

    var lan = navigator.language;
    if(lan == 'zh-CN'){
      this.changeLang('zh')
    }else{
      this.changeLang('en')
    }

    // this.changeLang(this.$i18n.locale);
    this.getImg();
    this.getimglunbo();
    this.getAppInfo();
    this.startInterval();
  },
  methods: {
    //开启定时器
    startInterval(){
      // 事件里定时器应该先清除在设置，防止多次点击直接生成多个定时器
      clearInterval(this.timer);
      this.timer = setInterval(()=>{
        this.currentIndex++;
        if(this.currentIndex > this.imgArr.length-1){
          this.currentIndex = 0
        }
      },2500)
    },
    //鼠标移入移出控制
    changeInterval(val){
      if(val){
        clearInterval(this.timer)
      }else{
        this.startInterval()
      }
    },
    tolooplay() {
      this.$router.push({
        path: "/looplay",
      });
    },
    tohalababy() {
      this.$router.push({
        path: "/halababy",
      });
    },
    downloadHalaBaby() {
      this.$download(this.halaUrl, {}, "halababy");
    },
    downloadIoof() {
      this.$download(this.ioofUrl, {}, "ioofox");
    },
    getAppInfo() {
      this.$post("/halababy/loofox/app/info", {}).then((res) => {
        this.halaUrl = this.$ip + "/file/download" + res.data.hala.fileUrl;
        this.ioofUrl = this.$ip + "/file/download" + res.data.ioof.fileUrl;
      });
    },
    getImg() {
      this.$post("/halababy/loofox/img", { pageNum: 1 }).then((res) => {
        this.imgSiteNum0 = this.$ip + res.data[0]["imgUrl"];
        this.imgSiteNum1 = this.$ip + res.data[1]["imgUrl"];
        this.imgSiteNum2 = this.$ip + res.data[2]["imgUrl"];
        this.imgSiteNum3 = this.$ip + res.data[3]["imgUrl"];
        this.imgSiteNum4 = this.$ip + res.data[4]["imgUrl"];
        this.imgSiteNum5 = this.$ip + res.data[5]["imgUrl"];
        this.imgSiteNum6 = this.$ip + res.data[6]["imgUrl"];
        this.imgSiteNum7 = this.$ip + res.data[7]["imgUrl"];
        this.imgSiteNum8 = this.$ip + res.data[8]["imgUrl"];
        this.imgSiteNum9 = this.$ip + res.data[9]["imgUrl"];
        this.imgSiteNum10 = this.$ip + res.data[10]["imgUrl"];
        this.imgSiteNum11 = this.$ip + res.data[11]["imgUrl"];
        this.imgSiteNum12 = this.$ip + res.data[12]["imgUrl"];
        this.imgSiteNum13 = this.$ip + res.data[13]["imgUrl"];
        this.imgSiteNum14 = this.$ip + res.data[14]["imgUrl"];
        this.imgSiteNum15 = this.$ip + res.data[15]["imgUrl"];
        this.imgSiteNum16 = this.$ip + res.data[16]["imgUrl"];
        this.imgSiteNum17 = this.$ip + res.data[17]["imgUrl"];
        this.imgSiteNum18 = this.$ip + res.data[18]["imgUrl"];
      });
    },
    getimglunbo() {
      this.$post("/halababy/loofox/imglunbo", { pageNum: 1 }).then((res) => {
        let arr = new Array();
        for(var index in res.data){
          let ar = {
            id: res.data[index]["id"],
            url: this.$ip + res.data[index]["imgUrl"]
          }
          arr.push(ar);
        }
        this.imgArr = arr;
      });
    },
    //修改语言
    changeLang(type) {
      this.$post("/halababy/loofox/text", { pageNum: 1 }).then((res) => {
        if (type == "zh") {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["content"]);
          }
          this.testList = arr;
        } else {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["contentEn"]);
          }
          this.testList = arr;
        }
      });
    },
    mouseOver(index){
      if(index == 0){
        this.bg0 = {
          background: 'url(' + require('../assets/index/in1.png') + ')',
        }
      }else{
        this.bg0 = {
          background: '',
        }
      }
      if(index == 1){
        this.bg1 = {
          background: 'url(' + require('../assets/index/in1.png') + ')',
        }
      }else{
        this.bg1 = {
          background: '',
        }
      }
      if(index == 2){
        this.bg2 = {
          background: 'url(' + require('../assets/index/in1.png') + ')',
        }
      }else{
        this.bg2 = {
          background: '',
        }
      }
    },
    mouseLeave(){
    }
  },
  data() {
    return {
      currentIndex :0,//当前所在图片下标
			timer:null,//定时轮询
      imgArr:[
			],
      bg0: this.bg0,
      bg1: this.bg1,
      bg2: this.bg2,
      testList:[],
      imgSiteNum0: this.imgSiteNum0,
      imgSiteNum1: this.imgSiteNum1,
      imgSiteNum2: this.imgSiteNum2,
      imgSiteNum3: this.imgSiteNum3,
      imgSiteNum4: this.imgSiteNum4,
      imgSiteNum5: this.imgSiteNum5,
      imgSiteNum6: this.imgSiteNum6,
      imgSiteNum7: this.imgSiteNum7,
      imgSiteNum8: this.imgSiteNum8,
      imgSiteNum9: this.imgSiteNum9,
      imgSiteNum10: this.imgSiteNum10,
      imgSiteNum11: this.imgSiteNum11,
      imgSiteNum12: this.imgSiteNum12,
      imgSiteNum13: this.imgSiteNum13,
      imgSiteNum14: this.imgSiteNum14,
      imgSiteNum15: this.imgSiteNum15,
      imgSiteNum16: this.imgSiteNum16,
      imgSiteNum17: this.imgSiteNum17,
      imgSiteNum18: this.imgSiteNum18,
    };
  },
};
</script>

<style>
.index {
  width: 100%;
}
.i_1 {
  width: 100%;
  height: 600px;
  background-size: 101%;
}
.i_1_ding {
  width: 1200px;
  height: 100%;
  margin: auto;
  position: relative;
}

/* .i_1_ding_1 img {
  position: absolute;
  top: 120px;
  left: 100px;
}
.i_1_ding_1 p {
  position: absolute;
  top: 120px;
  left: 450px;
  height: 38px;
  font-size: 44px;
  font-family: sucaijishikufangti;
  font-weight: 400;
  color: #ffffff;
}
.i_1_ding_2 p {
  position: absolute;
  top: 210px;
  left: 100px;

  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.8;
  letter-spacing: 37px;
} */
.halalogo {
  /* position: absolute;
  bottom: 156px;
  left: 120px; */
  cursor: pointer;
}
.yuhulogo {
  /* position: absolute;
  bottom: 156px;
  left: 370px; */
  cursor: pointer;
}
.app_down_word {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.halalogo_down {
  /* position: absolute;
  bottom: 120px;
  left: 155px; */
}
.yuhulogo_down {
  /* position: absolute;
  bottom: 120px;
  left: 405px; */
}
.halalogo_app {
  /* position: absolute;
  bottom: 91px;
  left: 140px; */
}
.yuhulogo_app {
  position: absolute;
  bottom: 91px;
  left: 395px;
}
.i_2 {
  width: 1200px;
  margin: 50px auto 0 auto;
}
.i_2 .i_2_cont {
  display: flex;
  width: auto;
  justify-content: space-between;
  flex-wrap: wrap;
}
.i_2_contimg:hover {
  animation: ani1 2s ease 0s 1 alternate forwards;
  -webkit-animation: ani1 2s ease 0s 1 alternate forwards;
}

@keyframes ani1 {
  0% {
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -transform: scale(1, 1);
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    -moz-transform: scale(1.2, 1.2);
    -transform: scale(1.2, 1.2);
  }
}
@-webkit-keyframes ani1 {
  0% {
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -transform: scale(1, 1);
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    -moz-transform: scale(1.2, 1.2);
    -transform: scale(1.2, 1.2);
  }
}
@-ms-keyframes ani1 {
  0% {
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -transform: scale(1, 1);
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    -moz-transform: scale(1.2, 1.2);
    -transform: scale(1.2, 1.2);
  }
}

.i_2 .i_2_cont div {
  width: 400px;
  height: 250px;
}
.i_2 .i_2_cont div p {
  margin-top: 40px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.i_3 {
  width: 1200px;
  margin: 50px auto 0 auto;
}
.i_3_cont {
  width: 100%;
  height: 400px;
  background-image: url("../assets/sz7.png");
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
.i_3_cont_1 {
  width: 379px;
  height: 339px;
  margin-top: 31px;
  position: relative;
  background-image: url("../assets/sz1.png");
}
.i_3_cont_1 .bgyuan {
  position: absolute;
  top: 46px;
  left: 46px;
  z-index: 1;
}
.i_3_cont_1 .bie_1 {
  position: absolute;
  top: 68px;
  left: 53px;
  z-index: 2;
}
.i_3_cont_1 .bgtiao {
  position: absolute;
  top: 68px;
  left: 107px;
  z-index: 0;
}
.i_3_cont_1 .i_3_cont_1_t {
  position: absolute;
  top: 80px;
  left: 170px;
  z-index: 2;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.i_3_cont_1 .i_3_cont_1_c {
  position: absolute;
  top: 172px;
  left: 51px;
  z-index: 2;
  width: 271px;
  height: 76px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 30px;
  text-align: left;
}
.i_4 {
  width: 1200px;
  margin: 79px auto 0 auto;
}
/* .i_4_abuout {
  font-size: 44px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #c0c0c0;
}
.i_4_lan {
  margin: 23px auto 0 auto;
  width: 88px;
  height: 6px;
  background-color: rgba(10, 177, 255, 1);
}

.i_4_jj {
  margin: 36px auto 34px auto;
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
}
.i_4_jjcon {
  width: 997px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #696969;
  line-height: 44px;
  margin: auto;
  text-align: left;
} */

.i_4_con {
  margin: 52px auto 0 auto;
  width: 969px;
  display: flex;
  justify-content: space-around;
}
.i_4_con_bg {
  width: 303px;
  height: 371px;
}
/* .i_4_con_bg:hover {
  background: url("../assets/index/in1.png");
} */
.i_4_con_bg:hover img {
  -webkit-transform: scale(1.3, 1.3);
  -moz-transform: scale(1.3, 1.3);
  -transform: scale(1.3, 1.3);
  z-index: 9999;
}
.i_4_con_bg img {
  margin-top: 30px;
}
.i_4_con_bg_sc {
  margin-top: 30px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.i_4 .i_4_con .xuxian {
  margin: 24px auto 0 auto;
  width: 240px;
  border-bottom: 1px dashed rgb(134, 133, 133);
}
.i_4_con_bg_ms {
  margin: 23px auto 0 auto;
  width: 227px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #696969;
  line-height: 26px;
}

.i_4_liaojie {
  margin-top: 36px;
  margin-bottom: 50px;
}
.i_4_liaojie a {
  display: inline-block;
  /* width: 10px; */
  padding: 0 50px;
  height: 64px;
  background-color: rgba(10, 177, 255, 1);
  border: none;
  cursor: pointer;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 64px;
  text-decoration: none;
  margin: auto;
}
.i_5 {
  width: 1200px;
  margin: 79px auto 20px auto;
}
.i_5_lapp {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: space-between;
}
.i_5_hala {
  width: 599px;
  height: 459px;
}
.i_5_hala:hover {
  background: url("../assets/index/in2.png");
}
.i_5_hala_s {
  width: 576px;
  height: 324px;
  margin: auto;
  position: relative;
}
.i_5_hala1_s {
  width: 576px;
  height: 324px;
  background-image: url("../assets/cp5.png");
  margin: auto;
  position: relative;
}
.i_5_hala_s1 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.i_5_hala_s2 {
  position: absolute;
  z-index: 1;
  top: 43px;
  left: 30px;
}

.i_5_hala_s3 {
  position: absolute;
  z-index: 1;
  top: 46px;
  left: 186px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fffefe;
}
.i_5_hala_s4 {
  position: absolute;
  z-index: 1;
  top: 85px;
  left: 30px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
}
.i_5_hala_s5 {
  position: absolute;
  z-index: 1;
  top: 173px;
  left: 30px;
  width: 160px;
  height: 44px;
  background-image: url("../assets/cp3.png");
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0ab1ff;
}
.i_5_hala_sx1 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 30px;
}
.i_5_hala_sx2 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 56px;
}
.i_5_hala_sx3 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 82px;
}
.i_5_hala_sx4 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 108px;
}
.i_5_hala_sx5 {
  position: absolute;
  z-index: 1;
  top: 124px;
  left: 134px;
}
.i_5_app_x {
  position: relative;
  width: 576px;
  height: 112px;
  margin: auto;
}
.i_5_app_x img {
  position: absolute;
  top: 11px;
  left: 21px;
}
.i_5_app_x p {
  position: absolute;
  top: 26px;
  left: 124px;
  width: 401px;
  height: 56px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
  line-height: 36px;
  text-align: left;
}

.app_download{
  text-align: left;
  width: 320px;
  padding-top: 300px;
  padding-left: 110px;
  display: flex;
  justify-content: space-between;
}
.app_download div{
  text-align: center;
}
.halababy_ix_3{
  padding-top: 60px;
  width: 620px;
  height: 440px;
}
.halababy_ix_2 div{
  width: 573px;
	height: 395px;
  border-radius:30px;
  position: absolute;
  top: 10px;
  left: 24px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.halababy_ix_2 img{
  height: 100%;
}
.halababy_ix_2{
  width: 620px;
  height: 440px;
  background: url("../assets/indexbanner.png") no-repeat;
  position: relative;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
.halababy_ix_1{
  /* letter-spacing: 20px; */
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 34px;
  /* opacity: 0.8; */
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue